module.exports = __webpack_public_path__ + "img/simphone.b42d26ed.png";